module.exports = __webpack_public_path__ + "img/job-3338100_1920.b82564ec.jpg";